export const PREDEFINED_REPORT = {
  GRIDCOLUMNS_predefinedReport_reportHistoryList: 'GRIDCOLUMNS_predefinedReport_reportHistoryList',
  GRIDCOLUMNS_predefinedReport_exportReportList: 'GRIDCOLUMNS_predefinedReport_exportReportList',
  GRIDCOLUMNS_predefinedReport_blockPreviewDetail:
    'GRIDCOLUMNS_predefinedReport_blockPreviewDetail',

  FILTERSEARCH_predefinedReport_reportHistoryList:
    'FILTERSEARCH_predefinedReport_reportHistoryList',
  FILTERSEARCH_predefinedReport_exportReportList: 'FILTERSEARCH_predefinedReport_exportReportList',

  FILTER_predefined_report_history: 'FILTER_predefined_report_history',
  FILTER_predefined_report_export: 'FILTER_predefined_report_export',
} as const;
